// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4eKXh","comment":"styles_comment__1kL7t"};